export const logout = () => {
  try {
    fetch("/api/v1/auth/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    }).then(() => {
      sessionStorage.clear();
      window.location.href = "/auth/login";
    });
  } catch (error) {
    console.error("Logout problem: ", error.message);
  }
};
